// 对接银行页面的 接口集合
import request from '../request.js'


// 银行列表 ---- 李开明
export const getBankList = function (data) {
    return request({
        url: 'operateDockBank/selectBanksPage',
        method: 'post',
        data
    })
}

// 银行启用状态改变 ---- 李开明
export const setBankStatus = function (data) {
    return request({
        url: 'operateDockBank/setBankStatus',
        method: 'post',
        data
    })
}

// 银行选择器 ---- 李开明
export const selectBanks = function (data) {
    return request({
        url: 'virtualAccount/selectBanks',
        method: 'post',
        data
    })
}
// 虚拟子账户列表 ---- 李开明
export const selectVirtualAccountPage = function (data) {
    return request({
        url: 'virtualAccount/selectVirtualAccountPage',
        method: 'post',
        data
    })
}
// 保证金列表 ---- 李开明
export const selectDepositRefundPage = function (data) {
    return request({
        url: 'marginRefund/selectDepositRefundPage',
        method: 'post',
        data
    })
}

